import { Table } from 'antd';
import { Enviroment } from '../../../../_config/constants/enviroment-v2.constant';
import { FormatNumber } from '../../../../_config/functions/format-number.function';
import { dictionaryProductColumn } from '../constants/dictionary-product-columns.constant';
import { checkRecipe } from './check-recipe.handle';
import { checkStatus } from './check-status.handle';
import { checkTotal } from './check-total.handle';
import { showIconDelete } from './show-icon-delete.handle';

import '../style.css';

export const generateProductColumns = (statusNumber, handleEditOffer, handleEditPrice, handleOpenRecipe, handleEditQuantity, handleOpenDelete) => {
	return [
		Table.EXPAND_COLUMN,
		{
			title: dictionaryProductColumn[Enviroment.LANGUAGE].name,
			dataIndex: 'name',
			key: 'name',
		},
		{
			title: dictionaryProductColumn[Enviroment.LANGUAGE].quantity,
			dataIndex: 'quantity',
			key: 'quantity',
			render: (quantity, record) => {
				return (
					<span onClick={() => (statusNumber === 100 ? handleEditQuantity(record) : null)}>
						{quantity} {checkStatus(statusNumber)}
					</span>
				);
			},
		},
		{
			title: dictionaryProductColumn[Enviroment.LANGUAGE].unit_price,
			dataIndex: 'unit_price',
			key: 'unit_price',
			render: (unit_price) => FormatNumber[Enviroment.LANGUAGE].handleFormat(unit_price),
		},
		{
			title: dictionaryProductColumn[Enviroment.LANGUAGE].disscount,
			dataIndex: 'discount',
			key: 'discount',
			render: (discount, record) => {
				return (
					<span onClick={() => (statusNumber === 100 ? handleEditOffer(record) : null)}>
						{FormatNumber[Enviroment.LANGUAGE].handleFormat(checkTotal(discount, record.quantity))} {checkStatus(statusNumber)}
					</span>
				);
			},
		},
		{
			title: dictionaryProductColumn[Enviroment.LANGUAGE].total,
			dataIndex: 'total_product',
			key: 'total_product',
			render: (total, record) => {
				return (
					<span onClick={() => (statusNumber === 100 ? handleEditPrice(record) : null)}>
						{FormatNumber[Enviroment.LANGUAGE].handleFormat(checkTotal(total, record.quantity))} {checkStatus(statusNumber)}
					</span>
				);
			},
		},
		{
			title: dictionaryProductColumn[Enviroment.LANGUAGE].total_products,
			dataIndex: 'total_product',
			key: 'total_product',
			render: (total_product) => FormatNumber[Enviroment.LANGUAGE].handleFormat(+total_product),
		},
		{
			title: dictionaryProductColumn[Enviroment.LANGUAGE].recipe,
			dataIndex: 'recipe',
			key: 'recipe',
			render: (recipe, record) => checkRecipe({ record: record, imgRecipe: recipe, openRecipe: handleOpenRecipe }),
		},
		{
			title: dictionaryProductColumn[Enviroment.LANGUAGE].actions,
			render: (record) => {
				return <span onClick={() => (statusNumber === 100 ? handleOpenDelete(record) : null)}>{showIconDelete(statusNumber)}</span>;
			},
		},
	];
};
